import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppConfig } from '../../../../config/app-config';
import { CLAIM_API_ENDPOINTS } from '../../../../endpoints.const';
import { searchCriteriaConfig } from '../../../../treo.properties';
import { LoaderService } from '../../../core/services/loading.service';
import { SharedService } from '../../../core/services/shared.service';
import { ClaimsService } from '../claims.service';
@Component({
    selector: 'app-selected-criteria',
    templateUrl: './selected-criteria.component.html',
    styleUrls: ['./selected-criteria.component.scss'],
    standalone: false
})
export class SelectedCriteriaComponent implements OnInit {
    public showCriteriaPanel: boolean = false;
    selectedCriteriaArr = searchCriteriaConfig;
    searchCriteriaParagraphConfig = AppConfig.searchCriteriaParagraphConfig;
    listItems = {};
    listItemKeys = [];
    positionOfLastKeyHavingData: number = 0;
    advanceSearchFilterId: any;
    routeSubscription$: Subscription;
    @Input() showbutton = false;
    @Output() showSaveFilterBox = new EventEmitter<boolean>();
    @Input() formId: string = '';

    toggleCriteriaPanel() {
        this.showCriteriaPanel = !this.showCriteriaPanel;
    }
    isDate(value: any): boolean {
        return typeof value === 'string' && value.includes('/') && value.length >= 8;
    }
    constructor(private readonly SharedService: SharedService, private route: ActivatedRoute,
        private claimsService: ClaimsService, private loaderService: LoaderService) {

        this.SharedService.advanceResultsData.subscribe((x) => {
            if (JSON.stringify(x) != '{}') {
                this.listItemKeys = [... new Set(this.listItemKeys.concat(Object.keys(x)))];
                this.listItems = { ...this.listItems, ...x };
                this.loaderService.setItem('listItems', JSON.stringify(this.listItems));

                this.listItemKeys.sort((a, b) => { return Number(a.split('_')[1]) - Number(b.split('_')[1]) });
                this.getPositionOfLastKey();
            }
        });
    }

    async ngOnInit() {
        this.routeSubscription$ = this.route.params.subscribe((params) => {
            this.advanceSearchFilterId = params['filterId']
            if (this.advanceSearchFilterId) {
                let constantItem = JSON.parse(this.loaderService.getItem('listItems'))
                this.listItemKeys = [... new Set(this.listItemKeys.concat(Object.keys(constantItem)))];
                this.listItems = { ...this.listItems, ...constantItem };
                this.listItemKeys.sort((a, b) => { return Number(a.split('_')[1]) - Number(b.split('_')[1]) });
                this.getPositionOfLastKey();
            }
        });

        this.SharedService.allReportsData$.subscribe((allData) => {
            if (allData[this.formId]) {
                // if (this.showCriteriaPanel) {
                //     this.showCriteriaPanel = false;
                // }
                const currentFormData = allData[this.formId] || {};

                this.listItemKeys = Object.keys(currentFormData);
                this.listItems = currentFormData;

                this.listItemKeys.sort((a, b) => Number(a.split('_')[1]) - Number(b.split('_')[1]));
                this.getPositionOfLastKey();
            }

        });
    }

    save(event: Event) {
        event.stopPropagation();
        event.preventDefault()
        this.showSaveFilterBox.emit(true);
        this.showbutton = false
        this.toggleCriteriaPanel();
    }

    resetValue() {
        this.listItems = {};
        this.listItemKeys = [];
    }

    saveFilter(event: Event) {

        let url = `${CLAIM_API_ENDPOINTS.FILTERS}`;

        const payload = {
            "claimInfo": {
                "orgnztnId": this.loaderService.getItem('orgId'),
                "filterManagement": {
                    "customFilters": [
                        {
                            "filterId": this.advanceSearchFilterId
                        }
                    ]
                }
            },
            "userId": this.loaderService.getItem('userId'),
            "claimDetailType": "FILTER_TEMPORARY",
            "actionType": "UPDATE"


        };

        this.claimsService.putData(url, payload).subscribe({
            next: (response: any) => {
                this.loaderService.hideLoader()
                event.stopPropagation();
                event.preventDefault()
                this.showSaveFilterBox.emit(true);
                this.showbutton = false
                this.toggleCriteriaPanel();

            },
            error: (error) => {
                console.error('Error updating data', error);
                this.loaderService.hideLoader()
            }
        });

    }

    getPositionOfLastKey() {
        Object.entries(this.listItemKeys).forEach(([key, value]) => {
            if (this.listItems[value] && this.listItems[value].length > 0)
                this.positionOfLastKeyHavingData = parseInt(key);
        });
    }

}
